import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, StateUtils) {

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.policyChange = StateUtils.activeDataForState(true).model;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-pc-bop-angular/paymentsDetails/paymentsDetailsCtrl.js
// module id = 1857
// module chunks = 0